import type React from 'react';
import { forwardRef } from 'react';
import { classNames } from 'tradera/utils/class-names';

import styles from './divider.module.scss';

import type { PolyRefFunction } from 'react-polymorphed';

const polyRef = forwardRef as PolyRefFunction;

export type DividerProps = React.PropsWithChildren<{
    dark?: boolean;
    className?: string;
    thick?: boolean;
    /**
     * Will hide `last-of-type` via CSS
     */
    hideLast?: boolean;
}>;

export const Divider = polyRef<'hr', DividerProps>(
    (
        { as, children, className, dark, thick, hideLast, ...props },
        forwardRef,
    ) => {
        const Component = as ?? (children ? 'div' : 'hr');
        const role = Component !== 'hr' ? 'separator' : undefined;

        return (
            <Component
                className={classNames(
                    styles.component,
                    dark && styles.dark,
                    hideLast && styles.hideLast,
                    thick && styles.thick,
                    className,
                )}
                ref={forwardRef}
                role={role}
                {...props}>
                {children ? (
                    <span className="d-inline-block px-2">{children}</span>
                ) : null}
            </Component>
        );
    },
);
